import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Button, Paper, Table, TableContainer, TablePagination,
} from '@mui/material';
import ProductModal from './ProductModal';
import useStyles from './styles';
import TableHeader from './TableHeader';
import TableContent from './TableContent';
import GenericConfirmationModal from '../../../../commons/GenericConfirmationModal';
import Loader from '../../../../commons/Loader';

const columns = [
  { id: 'groupNumber', label: 'Group Number', minWidth: 100 },
  { id: 'partNumber', label: 'Part Number', minWidth: 100 },
  { id: 'description', label: 'Description', minWidth: 100 },
  { id: 'actions', label: 'Actions', minWidth: 100 },
];

function createData(groupNumber, partNumber, description, actions, id) {
  return {
    groupNumber, partNumber, description, actions, id,
  };
}

export default function ProductsTable({
  page,
  setPage,
  modals,
  setOpenModal,
  fetchProductsData,
  products,
  deleteProduct,
}) {
  const [selectedProduct, setSelectedProduct] = useState('');
  const [rows, setRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const classes = useStyles();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleDeleteButtonClick = (event, product) => {
    event.stopPropagation();
    setSelectedProduct(product);
    setOpenModal('deleteProductConfirmation', true);
  };

  useEffect(() => {
    fetchProductsData();
  }, []);

  useEffect(() => {
    const tempArray = [];
    products?.['hydra:member']?.forEach((product) => {
      tempArray.push(createData(
        product.productGroup.number,
        product.partNumber,
        product.description,
        <Button
          className={classes.button}
          variant="contained"
          color="secondary"
          startIcon={<DeleteIcon />}
          onClick={(event) => handleDeleteButtonClick(event, product)}
        />,
        product['@id'],
      ));
    });
    setRows(tempArray);
  }, [products]);

  return (
    <>
      <Paper className={classes.root}>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" className={classes.productsTable}>
            <TableHeader columns={columns} />
            <TableContent page={page} rows={rows} rowsPerPage={rowsPerPage} columns={columns} />
            <Loader target="deleteContent" size={32} centeredX centeredY />
          </Table>
        </TableContainer>
        <Loader target="products" size={32} centeredX centeredY />
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        {modals.adminSingleProduct && <ProductModal />}
      </Paper>
      {modals.deleteProductConfirmation
      && (
      <GenericConfirmationModal
        confirmationType="deleteProductConfirmation"
        confirmedFunction={() => deleteProduct(selectedProduct['@id'])}
        informationalHeader={`You are going to delete product ${selectedProduct.description}`}
      />
      )}
    </>
  );
}

ProductsTable.propTypes = {
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  modals: PropTypes.objectOf(PropTypes.bool).isRequired,
  setOpenModal: PropTypes.func.isRequired,
  fetchProductsData: PropTypes.func.isRequired,
  products: PropTypes.objectOf(PropTypes.any).isRequired,
  deleteProduct: PropTypes.func.isRequired,
};
